import PickupAddressService from '../../services/PickupAddressService';
import userUseCase from './pickupAddressUseCase';

const userFactory = userUseCase({
  PickupAddressService: PickupAddressService(),
});

export default userFactory;
